module.exports = __webpack_public_path__ + "static/media/visa.8d008987.svg";